var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "abandonOptout",
        staticClass: "sign-in",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onAbandonOptout.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                !_vm.hideTitle
                  ? _c("h2", {
                      domProps: { innerHTML: _vm._s(_vm.$t("abandon.title")) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.abandonOptoutResponse.message
                  ? _c("GeneralMessage", {
                      attrs: {
                        message: _vm.abandonOptoutResponse.message,
                        type: _vm.abandonOptoutResponse.type,
                      },
                      on: {
                        close: function ($event) {
                          _vm.abandonOptoutResponse.message = ""
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "form-row__wrapper",
                  attrs: {
                    name: "token",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("abandon.tokenLabel"),
                                label: _vm.$t("abandon.tokenLabel"),
                                error: invalid && validated,
                                "error-message": errors[0],
                                disabled: _vm.disabled,
                                required: "",
                              },
                              model: {
                                value: _vm.abandonOptout.token,
                                callback: function ($$v) {
                                  _vm.$set(_vm.abandonOptout, "token", $$v)
                                },
                                expression: "abandonOptout.token",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("abandon.optoutButton"),
                    disabled: _vm.disabled,
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }